export default class TwoThreeCards {
    constructor() {
        this.twoThreeCards = document.querySelectorAll('.fd-block-23-cards');

        this.init();
    }

    init() {
        if(this.twoThreeCards.length) {
            this.twoThreeCards.forEach(() => {
                this.breakpoint = window.matchMedia('(min-width:1024px)');
                this.slider = undefined;

                this.breakpointChecker = this.breakpointChecker.bind(this);
                this.enableSwiper = this.enableSwiper.bind(this);
                this.breakpoint.addEventListener('change', this.breakpointChecker);
                this.breakpointChecker();
            })
        }
    }

    breakpointChecker() {
        if (this.breakpoint.matches === true) {
            if (this.slider !== undefined) this.slider.destroy(true, true);
        } else if (this.breakpoint.matches === false) {
            return this.enableSwiper();
        }
    }

    enableSwiper() {
        this.slider = new Swiper('.fd-23-cards', {
            slidesPerView: 1,
            slidesPerGroup: 1,
            centeredSlides: false,
            spaceBetween: 20,
            grabCursor: true,
            breakpoints: {
                640: {
                    slidesPerView: 2,
                }
            }
        })
    }
}